import React from "react";

import { Slider, Stack } from "@components/base";

interface SliderInput {}

const SliderInput: React.FC<SliderInput> = () => (
  <Stack p={3}>
    <Slider step={1} min={0} max={100} />
  </Stack>
);

export default SliderInput;
